import React from "react";
import "../VivaExam/VivaExam.css";

export const DummyQuestionTabs = ({ currentQuestion, setCurrentQuestion, questionStatus, questions }) => {
    console.log("[Tabs] Current question status:", questionStatus);
    const getTabClass = (qId) => {
        let cls = "question-tab";
        if (qId === questions[currentQuestion]?.Id) cls += " active-tab";
        if (questionStatus[qId] === "answered") cls += " completed-tab";
        return cls;
    };

    return (
        <div
            className="mt-2"
            id="question-tabs"
            style={{ display: "flex", justifyContent: "flex-start", padding: "0 16px", marginBottom: "16px", gap: "8px", flexWrap: "wrap" }}
        >
            {questions.map((qObj, idx) => {
                const isMandatory = qObj.IsMandatory === 1 || qObj.IsMandatory === "1";
                const isAnswered = questionStatus[qObj.Id] === "answered";

                return (
                    <button
                        key={qObj.Id}
                        className={getTabClass(qObj.Id)}
                        onClick={() => {
                            if (isAnswered) {
                                alert("This question has already been answered.");
                                return;
                            }
                            setCurrentQuestion(idx);
                        }}
                        disabled={isAnswered}
                        title={isMandatory ? "Mandatory Question" : ""}
                        style={{ position: "relative" }}
                    >
                        Q{idx + 1}
                        {isAnswered && <span style={{ marginLeft: "6px", color: "#4caf50", fontSize: "1.1em" }}>✓</span>}
                        {isMandatory && !isAnswered && (
                            <span style={{ color: "red", marginLeft: "5px", fontSize: "14px" }}>★</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};